import { type ActionEvent, Controller } from "@hotwired/stimulus";

// Connects to data-controller="saved-map-use", beside modal on the lists and the map's page (_use_dialog.html.erb).
// A card's Usar names the map in the page's one "Usar em uma campanha" dialog before modal#open shows it. A saved map goes by
// its id. A book's map goes by its key (the Montado's) or its Impresso's, which the version chips pick; the campaigns whose
// owner lacks the book are locked, since a scene takes the owner's books.
export default class extends Controller<HTMLElement> {
	static targets = ["name", "versions", "campaign", "bookTitle"];
	static values = { key: String, printed: String, book: String };
	declare readonly nameTargets: HTMLElement[];
	declare readonly versionsTarget: HTMLElement;
	declare readonly hasVersionsTarget: boolean;
	declare readonly campaignTargets: HTMLElement[];
	declare readonly bookTitleTargets: HTMLElement[];
	declare keyValue: string;
	declare printedValue: string;
	declare bookValue: string;

	choose({ params: { id, name, key, printed, book, bookTitle } }: ActionEvent) {
		this.fill("saved_map_id", id);
		this.fill("name", name);
		for (const target of this.nameTargets) target.textContent = name;
		if (key === undefined) return;
		this.keyValue = key;
		this.printedValue = printed ?? "";
		this.bookValue = book ?? "";
		this.fill("template_key", key);
		for (const input of this.inputs("background_kind")) input.disabled = false;
		for (const radio of this.element.querySelectorAll<HTMLInputElement>('input[name="version"]')) radio.checked = radio.value === "built";
		if (this.hasVersionsTarget) this.versionsTarget.hidden = !printed;
		for (const target of this.bookTitleTargets) target.textContent = bookTitle ?? "";
		for (const campaign of this.campaignTargets) {
			const usable = (campaign.dataset.ownerBooks ?? "").split(" ").includes(this.bookValue);
			const form = campaign.querySelector<HTMLElement>('[data-saved-map-use-target="form"]');
			const locked = campaign.querySelector<HTMLElement>('[data-saved-map-use-target="locked"]');
			if (form) form.hidden = !usable;
			if (locked) locked.hidden = usable;
		}
	}

	// Montado is the key with a blank background; Impresso is its own key and has no background of its own to ask for.
	version({ target }: Event) {
		const printed = target !== null && "value" in target && target.value === "printed";
		this.fill("template_key", printed ? this.printedValue : this.keyValue);
		for (const input of this.inputs("background_kind")) input.disabled = printed;
	}

	inputs(field: string) {
		return this.element.querySelectorAll<HTMLInputElement>(`input[name="map_scene[${field}]"]`);
	}

	fill(field: string, value: string | undefined) {
		if (value === undefined) return;
		for (const input of this.inputs(field)) input.value = value;
	}
}
